import logo from "@/assets/images/logo.svg";
import { Drawer, Layout, theme } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../contexts/auth/useAuthContext";
import {
  CHART_PREFIX,
  HOME,
  NEW_CHART
} from "../../routes";
import AppMenuContent from './AppMenuContent';
import { Footer } from "./Footer";
import Header from "./Header";
import { useLocation } from "react-router-dom";

const { Content, Sider } = Layout;
const { useToken } = theme;

interface Props {
  children: React.ReactNode;
}

const Main = ({ children }: Props) => {
  const { token } = useToken();
  const { t } = useTranslation();
  const { logout } = useAuthContext();
  const location = useLocation();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992); // Ant Design's 'lg' breakpoint is 992px
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 992);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const selectedKeys = [location.pathname];
  if (
    location.pathname === NEW_CHART ||
    location.pathname.startsWith(CHART_PREFIX)
  ) {
    selectedKeys.push(HOME);
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isSmallScreen ? (
        <Sider
          theme="light"
          width={200}
          style={{ borderRight: `1px solid ${token.colorBorderSecondary}` }}
        >
         <AppMenuContent
           logo={logo}
           token={token}
           selectedKeys={selectedKeys}
           t={t}
           onLogoutClick={logout}
         />
        </Sider>
      ) : (
        <Drawer
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          styles={{ body: { padding: 0 } }}
        >
         <AppMenuContent
           logo={logo}
           token={token}
           selectedKeys={selectedKeys}
           t={t}
           onLogoutClick={logout}
           onMenuItemClick={() => setDrawerOpen(false)} 
         />
        </Drawer>
      )}

      <Layout>
        <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isSmallScreen={isSmallScreen} />
        <Content style={{ margin: "16px", overflow: "initial" }}>
          {children}
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

export default Main;
